import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/feature/SEOHead";
import HomeContent from "./components/HomeContent";

export default function Home() {
  const orgJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "宅男视频",
    url: "https://zhainanvideo.com",
    description: "宅男视频提供91视频、97视频等数字品牌在线入口，免费高清播放，覆盖51视频网站及数字视频平台海量资源，播放流畅不缓冲。",
    slogan: "流畅不卡顿，免费高清在线观看",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      email: "support@zhainanvideo.com",
    },
  };

  return (
    <>
      <SEOHead
        title="宅男视频 - 91视频97视频在线观看与免费高清 51视频网站数字视频平台不卡顿"
        description="宅男视频提供91视频、97视频等数字品牌在线入口，免费高清播放，覆盖51视频网站及数字视频平台海量资源，播放流畅不缓冲。"
        keywords="宅男视频,91视频,97视频,91在线视频,51视频网站,数字视频平台,免费高清,在线观看,视频不卡顿,91视频免费"
        canonicalUrl="https://zhainanvideo.com"
        ogImage="https://readdy.ai/api/search-image?query=Digital%20video%20platform%20abstract%20brand%20image%20with%20warm%20orange%20and%20dark%20gradient%20theme%2C%20modern%20streaming%20service%20branding%2C%20clean%20minimal%20design%2C%20no%20text&width=1200&height=630&seq=og-home&orientation=landscape"
        ogImageAlt="宅男视频 - 数字视频平台"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HomeContent />
        </main>
        <Footer />
      </div>
    </>
  );
}